import Api from '@/services/Api'

export default {
  GetActiveEnvironment() {
    return Api().get('/user/environments/active/');
  },
  UpdateUserLanguage(language, environmentId) {
    return Api().put('/user/environments/' + environmentId + '/language/' + language);
  },
  SetFavoriteFilters(filters, environmentId) {
    return Api().post('/user/environments/' + environmentId + '/filters', {filters: filters});
  },
  RemoveFavoriteFilter(id) {
    return Api().delete('/user/filters/' + id);
  },
  GetBrandingForCustomer(environmentId) {
    return Api().get(`/brandings/${environmentId}/`)
  },
  SetUserEnvironment(id) {
    return Api().put('/user/environments/' + id + '/active/');
  }
}
